import React, { Component, Fragment, createRef } from 'react';
import { createPortal } from 'react-dom';
import { Select, Input, Button } from "antd";
import Panel from '@/components/Panel';
import NetListModel from '../../../components/NetListModel';
import UnitAddonAfter from '../../../components/UnitAddonAfter';
import { checkRLCValue } from '@/services/helper/dataProcess';
import { getRLInputKey, splitRLValue } from '../../../services/Cascade/helper/rlModelHelper';
import TagsInput from '@/components/TagsInput';
import {
  RLModelInfo,
  RLTypeList,
  defaultRLValue,
  PassiveModel,
  getModelTypeName,
  changeModelToNetListModel,
  changeNetListModelToModel
} from '../../../services/Cascade/helper/rlModel';
import { getTreeSelectList } from '../../../services/Cascade/library';
import '../../../publicCss/style.css';
import '../../../publicCss/aurora.css';
import './index.css';

const TOUCHSTONE = "touchstone", SPICE = "spice", VALUE = "value";

class RLModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: new RLModelInfo({ modelType: VALUE }),
      rl: { r: '0', l: '0' },
      unit: { r: 'Ω', l: 'n' },
      subcktList: [],
      pins: [],
      R_values: []
    };
    this.inputRef = createRef();
    this.dialogRoot = document.getElementById('root');
    this.base_SingleValue = false
  }

  componentWillMount() {
    const { record, isSweepBase, passivePins = [] } = this.props;
    const { components } = record;
    const model = record.model ? JSON.parse(JSON.stringify(record.model)) : new RLModelInfo({ modelType: "value" });
    if (isSweepBase) {
      this.base_SingleValue = !Object.keys(model.value).includes('c')
      this.setState({
        R_values: [record.value]
      })
    }

    let pins = [];
    if (!passivePins || passivePins.length === 0) {
      for (const comp of components) {
        const _pins = comp && comp.pins ? comp.pins : []
        pins = [...pins, ...(_pins.map(item => item.pin))];
      }
    } else {
      pins = passivePins
    }
    let _pins = [...(new Set(pins))];
    const valueObj = model.value;
    let rlResult = splitRLValue({ R: valueObj.r || "", L: valueObj.l || "" });
    rlResult = Object.assign(defaultRLValue, rlResult);
    this.setState({
      rl: { r: rlResult.R.value, l: rlResult.L.value },
      unit: { r: rlResult.R.unit, l: rlResult.L.unit },
      pins: _pins.sort(),
      model
    })
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.sweepCreateStatus === true && this.props.sweepCreateStatus === false) {
      this.props.save()
    }
  }

  closeModal = () => {
    const { rl, unit } = this.state;
    const { record } = this.props;
    let model = { ...this.state.model };
    // get model data
    let modelInfo = {};
    if (this.modelChild) {
      modelInfo = this.modelChild.getNetListModel();
      modelInfo = changeNetListModelToModel(modelInfo);
    }
    let _unit = "";
    if (model.type === VALUE) {
      model.value = {
        r: checkRLCValue(rl.r + (unit.r === 'Ω' || parseFloat(rl.r) === 0 ? '' : unit.r)),
        l: checkRLCValue(rl.l + (parseFloat(rl.l) === 0 ? "" : unit.l)),
      };
      model = new RLModelInfo({ modelType: VALUE, value: { ...model.value } });
    } else {
      model.passiveModel = modelInfo;
    }
    this.props.saveRLModel(model, record, _unit);
    this.props.save();
  }

  selectModelType = (key) => {
    this.setState({
      model: {
        ...this.state.model,
        type: key,
        passiveModel: new PassiveModel({})
      }
    }, () => {
      // reset model data
      if (this.modelChild) {
        this.modelChild.resetModel();
      }
    })
  }

  changeRLValue(e, type, _unit) {
    const { rl, unit } = this.state;
    let _rl_ = { ...rl }, _unit_ = { ...unit };
    if (e !== null) {
      _rl_[type] = e.target.value;
    }
    if (_unit !== null) {
      _unit_[type] = _unit;
    }
    this.setState({
      rl: _rl_,
      unit: _unit_
    })
  }

  RLBlur = (e, type) => {
    const rl = { ...this.state.rl };
    if (!this.base_SingleValue) {
      rl[type] = checkRLCValue(e.target.value);
      this.setState({
        rl
      })
    }
  }

  onRef = (ref) => {
    this.modelChild = ref;
  }

  getRLInputList = (type) => {
    const { rl, unit } = this.state;
    const arr = getRLInputKey(type).map(item => ({
      inputVal: rl[item.key],
      selectVal: unit[item.key],
      placeholder: item.placeholder,
      units: item.units,
      type: item.key
    }))
    return this.getRLInputComponent(arr);
  }

  addonAfter = (item) => {
    return UnitAddonAfter({
      unit: item.selectVal,
      changeUnit: (key) => this.changeRLValue(null, item.type, key),
      list: item.units
    })
  }

  changeR_values = (type, list) => {
    this.setState({
      R_values: list.map(item => checkRLCValue(item.replace(/ /, '').replace(/Ω/, '')))
    })
  }

  getRLInputComponent(arr) {
    const { R_values } = this.state
    return arr.map(item => this.base_SingleValue ?
      <TagsInput
        tagList={R_values}
        className={'cascade-rl-value-tagsInput'}
        allowedDuplicates={true}
        changeTagList={this.changeR_values}
        key={item.type}
        addonAfter={this.addonAfter(item)}
        unit={item.selectVal}
        unitOptions={item.units}
        isAddonAfter={true}
      ></TagsInput>
      :
      <Input
        addonAfter={this.addonAfter(item)}
        key={item.type}
        style={{ marginBottom: '10px' }}
        value={item.inputVal}
        placeholder={item.placeholder}
        onChange={(e) => this.changeRLValue(e, item.type, null)}
        onBlur={(e) => this.RLBlur(e, item.type)}
      />
    )
  }

  createExpsByPassive = () => {
    const { R_values } = this.state
    const { createExpsByPassive, record, isSweepBase, updateCreateStatus } = this.props
    if (isSweepBase) {
      const multipleValues = R_values.filter(item => item !== record.value)
      createExpsByPassive(multipleValues, record)
    }
    updateCreateStatus(true)
  }

  renderDialog() {
    const { model, pins } = this.state;
    const modelType = getModelTypeName(model.type);
    const _passiveModel = changeModelToNetListModel(model.passiveModel)
    const { spiceList, touchstoneList, product, record, getFileContent, parseModelSelector, getPopupContainerId, title, sweepCreateStatus } = this.props;
    const content = (
      <Panel
        className='cascade-rl-model-panel'
        title={<div className='cascade-rl-model-title'>{title ? title : record.part}</div>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={500}
        minWidth={450}
        minHeight={200}
        position='panel-center'
        draggable
      >
        <div className='cascade-rl-model-content'>
          <div className='cascade-rl-model-row'>
            <span>Model Type</span>
            <Select
              placeholder='Type'
              value={model.type || undefined}
              onChange={this.selectModelType}
              className='cascade-rl-model-selection'
              popupClassName='cascade-rl-model-select-dropdown'
              showSearch
              popupMatchSelectWidth={false}
              getPopupContainer={() => document.getElementById('root')}
              options={RLTypeList.map(item => ({
                value: item.key,
                label: item.title,
                title: item.title
              }))}
            />
          </div>
          {
            model.type === VALUE && <div className='cascade-rl-model-row'>
              <span style={{ alignSelf: 'flex-start' }}>Value</span>
              <div>
                {this.getRLInputList(record.COMP_TYPE)}
              </div>
            </div>
          }
          {
            (model.type === TOUCHSTONE || model.type === SPICE) && <NetListModel
              onRef={this.onRef}
              spiceList={spiceList}
              touchstoneList={touchstoneList}
              getPopupContainerId={getPopupContainerId}
              pins={pins}
              product={product}
              modelType={modelType}
              model={{ type: modelType, ..._passiveModel }}
              getFileContent={getFileContent}
              parseModelSelector={parseModelSelector}
              getTreeSelectList={getTreeSelectList}>
            </NetListModel>
          }
          {
            this.base_SingleValue && <div className='cascade-rl-sweep-create'>
              <Button type="primary" className='cascade-rl-sweep-create-btn' loading={sweepCreateStatus} onClick={() => this.createExpsByPassive()}>Create</Button>
            </div>
          }
        </div>
      </Panel >
    )
    return createPortal(content, this.dialogRoot);
  }

  render() {
    const { inputRef } = this;
    return (
      <Fragment>
        <div className='editable-cell-value-wrap' ref={inputRef}>
          {this.props.text}
        </div>
        {this.renderDialog()}
      </Fragment>
    )
  }
}

export default RLModel;